import { SmartLink } from "components/smart-link";
import * as styles from './subscribe-banner.module.scss';
import React from "react";

type SubsBannerType = {
  nameLink: string;
  link: string;
}

export const SubscribeBanner = ({nameLink,link }: SubsBannerType) => {
  return(
    <div className={styles.bannerWrapper}>
      <p className={styles.bannerTitle}>Subscribe for dental tips</p>
      <SmartLink
      key={nameLink}
      ariaLabel={nameLink}
      to={link}
      className={styles.buttonStyle}
      >
      {nameLink}
      </SmartLink>
    </div>
  );
};
